// @flow
/**
 * @module Reducers/BankStatements
 * @desc Bank Statements Reducer
 */

import { handleActions } from 'redux-actions';
import { BankStatementsConstants } from 'constants/bankStatementsConstants';
import { requestFail, requestPending, requestSuccess } from 'components/Request';

const initialState = {
  isLoading: false,
  statements: [],
  dataVersion: 0,
  error: null,
};

export default handleActions({
  [requestPending(BankStatementsConstants.GET_STATEMENTS)]: state => ({
    ...state,
    isLoading: true,
  }),
  [requestSuccess(BankStatementsConstants.GET_STATEMENTS)]: (state, action) => ({
    ...state,
    statements: action.payload,
    isLoading: false,
  }),
  [requestFail(BankStatementsConstants.GET_STATEMENTS)]: (state, action) => ({
    ...state,
    error: action.payload,
    isLoading: false,
  }),

  [BankStatementsConstants.SET_DATA_VERSION]: (state, action) => ({
    ...state,
    dataVersion: action.payload,
  }),
}, initialState);
